"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HotspotWrapper = exports.fade = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("./hotspot.constants");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
var fadeOut = (0, _styledComponents.keyframes)(["from{opacity:1;}to{opacity:0;}"]);

var fade = function fade(playing, shouldFadeOut) {
  return (0, _styledComponents.css)(["", " ", "s ease-in-out "], playing && shouldFadeOut ? fadeOut : fadeIn, _hotspot.FADE_TIME);
};

exports.fade = fade;

var HotspotWrapper = _styledComponents.default.div.attrs(function (_ref) {
  var containerStyles = _ref.containerStyles;
  return {
    style: {
      height: "".concat(containerStyles.height, "%"),
      left: "".concat(containerStyles.left, "%"),
      top: "".concat(containerStyles.top, "%"),
      width: "".concat(containerStyles.width, "%"),
      zIndex: containerStyles.zIndex
    }
  };
}).withConfig({
  displayName: "hotspotstyles__HotspotWrapper",
  componentId: "sc-1gki5xv-0"
})(["animation:", ";animation-iteration-count:1;animation-fill-mode:forwards;position:absolute;", ""], function (_ref2) {
  var playing = _ref2.playing,
      shouldFadeOut = _ref2.shouldFadeOut;
  return fade(playing, shouldFadeOut);
}, function (props) {
  return props.customPlayer && "\n    pointer-events: all;\n  ";
});

exports.HotspotWrapper = HotspotWrapper;

var ClickableArea = _styledComponents.default.button.withConfig({
  displayName: "hotspotstyles__ClickableArea",
  componentId: "sc-1gki5xv-1"
})(["background:transparent;border:none;cursor:pointer;font-size:inherit !important;height:100%;padding:0;width:100%;&:focus{}div{box-sizing:border-box;}"]);

var _default = ClickableArea;
exports.default = _default;